import {Action} from "@ngrx/store";

export const LOAD_BOOSTER_DATA: string = '[website] Load Booster Data';
export const LOAD_BOOSTER_DATA_SUCCESS: string = '[website] Load Booster Data Success';
export const LOAD_BOOSTER_DATA_FAIL: string = '[website] Load Booster Data Fail';
export const LOAD_BOOSTER_OPTIMIZE_STATUS: string = '[website] Load Booster Optimize Status';
export const LOAD_BOOSTER_OPTIMIZE_STATUS_SUCCESS: string = '[website] Load Booster Optimize Status Success';
export const LOAD_BOOSTER_OPTIMIZE_STATUS_FAIL: string = '[website] Load Booster Optimize Status Fail';
export const LOAD_BOOSTER_AUTO_OPTIMIZE: string = '[website] Load Booster Auto Optimize';
export const LOAD_BOOSTER_AUTO_OPTIMIZE_SUCCESS: string = '[website] Load Booster Auto Optimize Success';
export const LOAD_BOOSTER_AUTO_OPTIMIZE_FAIL: string = '[website] Load Booster Auto Optimize Fail';

export class LoadBoosterData implements Action {

  readonly type: string = LOAD_BOOSTER_DATA;
  constructor(public payload:  {
    websiteId: number
  }) {}

}

export class LoadBoosterDataSuccess implements Action {

  readonly type: string = LOAD_BOOSTER_DATA_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    pages: any,
    customPages: any,
    modeLevel: any,
    incompatibleActivePlugins: any,
    pagesCount: number,
    testMode: any,
    pageCacheStatus: any,
    webpStatus: any,
    pluginInfo: any,
  }) {}

}

export class LoadBoosterDataFail implements Action {

  readonly type: string = LOAD_BOOSTER_DATA_FAIL;
  constructor(public payload: {
    websiteId: number
  }) {}

}

export class LoadBoosterOptimizeStatus implements Action {

  readonly type: string = LOAD_BOOSTER_OPTIMIZE_STATUS;
  constructor(public payload:  {
    websiteId: number,
    pageUrl: string
  }) {}

}

export class LoadBoosterOptimizeStatusSuccess implements Action {

  readonly type: string = LOAD_BOOSTER_OPTIMIZE_STATUS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    optimizeStatus: any
  }) {}

}

export class LoadBoosterOptimizeStatusFail implements Action {

  readonly type: string = LOAD_BOOSTER_OPTIMIZE_STATUS_FAIL;
  constructor(public payload: {
    websiteId: number
  }) {}

}

export class LoadBoosterAutoOptimize implements Action {

  readonly type: string = LOAD_BOOSTER_AUTO_OPTIMIZE;
  constructor(public payload:  {
    websiteId: number
  }) {}

}

export class LoadBoosterAutoOptimizeSuccess implements Action {

  readonly type: string = LOAD_BOOSTER_AUTO_OPTIMIZE_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    autoOptimizeEnabled: any
  }) {}

}

export class LoadBoosterAutoOptimizeFail implements Action {

  readonly type: string = LOAD_BOOSTER_AUTO_OPTIMIZE_FAIL;
  constructor(public payload: {
    websiteId: number
  }) {}

}

export type BoosterDataAction = LoadBoosterData | LoadBoosterDataSuccess | LoadBoosterDataFail
  | LoadBoosterOptimizeStatus | LoadBoosterOptimizeStatusSuccess | LoadBoosterOptimizeStatusFail
  | LoadBoosterAutoOptimize | LoadBoosterAutoOptimizeSuccess | LoadBoosterAutoOptimizeFail;
